import React from 'react';

interface GmailMarkProps {
  width?: number;
  height?: number;
  className?: string;
}

const GmailMark: React.FC<GmailMarkProps> = ({ width = 32, height = 24, className }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 24"
    aria-label="Gmail"
    role="img"
    className={className}
  >
    <path fill="#4285F4" d="M2 22V8.5L0 7v13a2 2 0 0 0 2 2h4v-2H2z" />
    <path fill="#34A853" d="M26 22h4a2 2 0 0 0 2-2V7l-2 1.5V22h-4z" />
    <path fill="#FBBC04" d="M26 4.2v18h4V2L26 4.2z" />
    <path fill="#EA4335" d="M2 22V4.2L0 2v18a2 2 0 0 0 2 2h4v-2H2z" />
    <path fill="#C5221F" d="M26 4.2 16 12 6 4.2 2 4.2 16 14.5 30 4.2z" />
  </svg>
);

export default GmailMark;
